"use client";

import { useEffect } from "react";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import type { Profile } from "../../models";
import {
  PostHogFlagsProvider,
  type PostHogFlags,
} from "./posthog-flags-provider";

export const identifyUser = (profile: Profile) => {
  posthog.identify(profile.user.auth.provider_id, {
    // TODO: (kjiang) Enable name and email once 30 days of being in trust is over. (June 15, 2025)
    // email: profile?.user.email,
    // name: profile?.user.name,
    internal_id: profile?.user.id,
  });
};

interface PostHogClientProviderProps {
  children: React.ReactNode;
  flags: PostHogFlags;
  distinctID?: string;
}

export function PostHogClientProvider({
  children,
  flags,
  distinctID,
}: PostHogClientProviderProps) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host: "/a",
      ui_host: "https://us.posthog.com",
      person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
      capture_pageview: "history_change",
      bootstrap: {
        featureFlags: flags,
        distinctID: distinctID,
      },
    });
  }, []);

  return (
    <PHProvider client={posthog}>
      <PostHogFlagsProvider flags={flags}>{children}</PostHogFlagsProvider>
    </PHProvider>
  );
}
